var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestTabletLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.39 14.7S14.7 9.38 14.7 3.675C14.7 2.38 13.055 0 11.025 0S7.35 1.029 7.35 2.131C7.35 1.03 5.705 0 3.675 0S0 2.307 0 3.675C0 9.453 7.39 14.7 7.39 14.7"
})));
export default SvgPinterestTabletLike;